module.exports = __webpack_public_path__ + "img/mt5Logo2.ad764abd.svg";